export const IOC_TYPES = {
  TasksStore: Symbol.for('TasksStore'),
  GanttStore: Symbol.for('GanttStore'),
  TaskUpdateFifoQueue: Symbol.for('TaskUpdateFifoQueue'),
  UIStore: Symbol.for('UIStore'),
  GanttContextStore: Symbol.for('GanttContextStore'),
  ScheduleStore: Symbol.for('ScheduleStore'),
  ApiClient: Symbol.for('ApiClient'),
  FirebaseTokenProvider: Symbol.for('FirebaseTokenProvider'),
} as const;
